interface GetTextWidthOptions {
  text: string;
  fontSize: string;
}

export const getTextWidth = ({ text, fontSize }: GetTextWidthOptions) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) {
    return null;
  }

  context.font = `${fontSize} Inter`;
  const metrics = context.measureText(text);
  return metrics.width;
};
